import { Text, ButtonInterface, Preloader } from '@portals/ui-kit';
import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import styles from './index.module.scss';
import { FeedbackDrawerWrapper } from '../feedback-drawer-wrapper';

const BLOCK_NAME = 'Feedback-success-modal';
const cn = classnames.bind(styles);

type TProps = {
  isOpened: boolean;
  onClose: () => void;
  isLoading: boolean;
  isInDrawer?: boolean;
};

export const FeedbackSuccessModal = ({
  isOpened,
  onClose,
  isLoading,
  isInDrawer,
}: TProps) => {
  const translations = useTranslations('article.feedbackSuccessModal');
  const title = translations('title');
  const buttonText = translations('close');

  const content = (
    <div
      className={cn(BLOCK_NAME, {
        [`${BLOCK_NAME}--in-drawer`]: isInDrawer,
        [`${BLOCK_NAME}--size`]: !isInDrawer,
      })}
    >
      {isLoading ? (
        <Preloader dataTestid="feedback-success-modal" />
      ) : (
        <>
          <div className={cn(`${BLOCK_NAME}__title`)}>
            <Text size="title-l-bold" text={title} whiteSpace="pre-wrap" />
          </div>
          <div className={cn(`${BLOCK_NAME}__controls`)}>
            <ButtonInterface onClick={onClose} text={buttonText} />
          </div>
        </>
      )}
    </div>
  );

  return (
    <>
      {isOpened && (
        <FeedbackDrawerWrapper
          isOpened={isOpened}
          onClose={onClose}
          isInDrawer={isInDrawer}
        >
          {content}
        </FeedbackDrawerWrapper>
      )}
    </>
  );
};
